// @ts-ignore
import { trans } from '@/mixins/i18n';
import { usePage } from '@inertiajs/vue3';
import { DateTime } from 'luxon';

export const formatLastUpdated = (dateString: string | null | undefined): string | null => {
    if (!dateString) return null;

    const localDateTime = DateTime.fromISO(dateString).toLocal();

    if (!localDateTime.isValid) {
        return null;
    }

    const diffInSeconds = Math.abs(localDateTime.diffNow('seconds').seconds);
    if (diffInSeconds > 0 && diffInSeconds <= 60) {
        return trans('general.just_now');
    }

    return localDateTime.setLocale(usePage().props.locale as string).toRelative({ rounding: 'ceil' });
};
